module.exports = __webpack_public_path__ + "static/st1-8-11c75c46a52618e0ae8513ca0d1dcd18.jpg";